import Axios from "axios";
import Apis from "../../config/Apis";
import { hideLoading, showLoading, showAlert } from "../Actions/GeneralActions";
// import { headers } from '../../Utils';
import {
  getPaymentCards,
  getSubscriptions,
  updateActiveCards,
  updatePaymentCards,
} from "../Actions/PaymentActions";
// import Storage from '../../Utils/AsyncStorage';
// import { userData } from '../Actions/AuthAction';
import { headers } from "../../utills";
import Storage from "../../utills/AsyncStorage";
import { getUser } from "../Actions/AuthAction";

export const PaymentMiddleware = {
  getSubscriptions: () => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const data = await Axios.get(
            Apis.subscriptions,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(hideLoading());
            dispatch(getSubscriptions(data?.data?.data));
            resolve(data?.data?.data);
          }
        } catch (error) {
          dispatch(hideLoading());
          reject(error);
          dispatch(
            showAlert({
              title: "getSubscriptions",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  getAllCards: () => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          const data = await Axios.get(
            Apis.paymentCards,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);

            dispatch(getPaymentCards(data?.data?.data));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "getAllCards",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },

  addCard: (userData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("card_number", userData?.card_number);
          formdata.append("exp_date", userData?.exp_date);
          formdata.append("cvc", userData?.cvv);
          formdata.append("card_holder_name", userData?.card_holder_name);

          const data = await Axios.post(
            Apis.storeCard,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message })
            );
            dispatch(updatePaymentCards(data?.data?.data));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "addCard",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  deleteCard: (card_id, index) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("stripe_source_id", card_id);
          const data = await Axios.post(
            Apis.deleteCard,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message })
            );
            dispatch(updateActiveCards(index));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "deleteCard",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  payNow: (payment_data) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("subscription_id", payment_data?.sub_id);
          formdata.append("payment_card_id", payment_data?.card_id);

          const data = await Axios.post(
            Apis.buySubscription,
            formdata,
            await headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(showAlert({ message: data?.data?.message }));
            Storage.setUser(
              "@user",
              JSON.stringify(data?.data?.data?.user_data)
            );
            dispatch(getUser(data?.data?.data?.user_data));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "payNow",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
};
